import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GasNotifyBarComponent } from './bar/gas-notify-bar.component';
import { GasNotifyWrapperComponent } from './wrapper/gas-notify-wrapper.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasNotifyToastComponent } from './toast/gas-notify-toast.component';

const COMPONENTS = [
  GasNotifyBarComponent,
  GasNotifyWrapperComponent,
  GasNotifyToastComponent,
];

@NgModule({
  imports: [
    CommonModule,
    GasIconsModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  entryComponents: [
    GasNotifyWrapperComponent,
  ],
})
export class GasNotifyModule { }
